import { useEffect, type ReactNode } from 'react';
import { pageTitle } from '@/lib/page-title';
import { Navbar } from '@/components/layout/Navbar';
import { Footer } from '@/components/layout/Footer';

interface StorybookShellProps {
  /** document.title while this page is open. Never include the child's name. */
  title: string;
  children: ReactNode;
}

/**
 * Frame for every storybook page: the site's (dark) Navbar and Footer around a
 * <main> that switches to the storybook's own bright palette (.storybook-theme
 * in index.css).
 */
export function StorybookShell({ title, children }: StorybookShellProps) {
  useEffect(() => {
    const previous = document.title;
    document.title = pageTitle(title);
    return () => {
      document.title = previous;
    };
  }, [title]);

  return (
    <div className="min-h-screen overflow-x-hidden bg-background">
      <Navbar />
      <main className="storybook-theme min-h-screen bg-background pt-16 text-foreground">
        {children}
      </main>
      <Footer />
    </div>
  );
}
